module.exports = __webpack_public_path__ + "img/imgplay2.10138cb6.png";